import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import FlexView from 'react-flexview/lib';

import Auxiliary from '../Auxiliary';
import Toolbar from './Toolbar';
import Footer from './Footer';
import Drawer from './Drawer';

export default React.memo(function Layout(props) {
	const [timer, setTimer] = useState(false);
	useEffect(() => {
		setTimeout(() => {
			setTimer(true);
		}, 5500);
	});
	const drawer = useSelector((state) => {
		return state.drawer;
	});

	let centerDenominator = window.matchMedia('(max-width: 1200px').matches
		? 2.8
		: 2;
	const centerX = window.screen.width / centerDenominator;
	const centerY = window.screen.height / centerDenominator;
	const [mousePos, setMousePos] = useState({ X: centerX, Y: centerY });
	const X = (75 / centerX) * (mousePos.X - centerX);
	const Y = (75 / centerY) * (mousePos.Y - centerY);

	const mousePosFetcher = (e) => {
		setMousePos({ X: e.clientX, Y: e.clientY });
	};

	const [swell, setSwell] = useState(0);
	const eyeSweller = () => {
		swell === 0 ? setSwell(1) : setSwell(0);
	};

	let mobile = window.matchMedia('(max-width: 600px)').matches ? true : false;

	let mouseMoveHandler = !mobile && timer ? mousePosFetcher : null;
	let clickHandler = !mobile && timer ? eyeSweller : null;

	const main = drawer ? <Drawer /> : props.children;

	return (
		<Auxiliary>
			<FlexView
				column
				vAlignContent="center"
				hAlignContent="center"
				onMouseMove={mouseMoveHandler}
				onClick={clickHandler}
			>
				<Toolbar X={X} Y={Y} eyeSweller={swell} />
				<main>{main}</main>
				<Footer />
			</FlexView>
		</Auxiliary>
	);
});
